// Basic
import PropTypes from 'prop-types';
// Components
import Icon from '../icon/Icon';
import Entity from '../entity/Entity';
import { Separator } from '../../ui/separator';
// Common
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsPreLogin } from '@/app/i18n/namespaces';

/**
 * @param validationStatus.validationStatus
 * @param {Array} validationStatus list of fields status
 *@returns {JSX} list of validations of a passsword
 */
function PasswordValidation({ validationStatus }) {
    return (
        <ul className='flex flex-row mt-2'>
            {validationStatus.map((rule, index) => (
                <li
                    key={rule.label}
                    className='flex items-center mt-1 gap-[0.2rem]'
                >
                    {index > 0 && index < validationStatus.length && <Separator className='ml-2' orientation='vertical' />}
                    {rule.test ?
                        <Icon icon={ICONS.VALIDATE} size={12} strokeWidth={4} className='text-success-foreground' />
                        : <Icon icon={ICONS.CLOSE} size={12} strokeWidth={4} className='text-danger-foreground' />
                    }
                    <Entity namespace={nsPreLogin} entity={rule.label} className='text-xs italic font-normal' />
                </li>
            ))}
        </ul>
    );
}
PasswordValidation.propTypes = {
    validationStatus: PropTypes.array
};

export default PasswordValidation;